import React from 'react';
import styles from '../../../assets/scss/6-pages/superAdmin/overview.module.scss';
import InfoIcon from '../../../assets/img/info-circle.svg';
import TooltipBox from '../../../components/base/Overlay/TooltipBox';

interface RunningProcessSlideCardProps {
  icon: string; // SVG path
  iconAlt: string;
  iconBg: string;
  date: string;
  title: string;
  period: string;
  cardBg: string;
  tail?: boolean;
  tailClassName?: string;
  id: string;
  notifyText?: string;
}

const RunningProcessSlideCard: React.FC<RunningProcessSlideCardProps> = ({
  id,
  icon,
  iconAlt,
  iconBg,
  date,
  title,
  period,
  cardBg,
  tail = true,
  tailClassName,
  notifyText,
}) => {
  return (
    <div className={styles.processSlideCard} style={{ background: cardBg }}>
      {/* Info icon top right */}
      {notifyText && (
        <TooltipBox msg={notifyText} id={id} hideDelay={0} contentClassName={styles.slideTooltipContent}>
          <img src={InfoIcon} alt="info" className={styles.infoIcon} />
        </TooltipBox>
      )}
      {/* Card tail arrow (not shown on last slide) */}
      {tail && <span className={`${styles.cardTail} ${tailClassName ? styles['cardTail__' + tailClassName] : ''}`} />}
      <div className={styles.cardRow}>
        {/* Icon column */}
        <div className={styles.iconBox}>
          <img src={icon} alt={iconAlt} className={styles.iconImg} />
        </div>

        {/* Content column */}
        <div className={styles.contentCol}>
          {/* Date/time */}
          <div className={styles.dateText}>{date}</div>
          {/* Title and period */}
          <div className={styles.titlePeriod}>
            <div className={styles.title}>{title}</div>
            <div className={styles.period}>Period: {period}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RunningProcessSlideCard;
